/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EnablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOf
 */
export interface EnablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOf
     */
    'cardType': EnablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const EnablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type EnablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOfCardTypeEnum = typeof EnablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOfCardTypeEnum[keyof typeof EnablePhysicalStorePaymentForTheUserAccount200ResponseReissueOneOfCardTypeEnum];


